var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWinterStickMRSkull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 77,
    viewBox: "0 0 54 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3056 31.7958C27.3056 31.7958 41.1427 36.4082 51.8105 29.7773C51.8105 29.7773 53.829 32.0835 53.2536 34.3897C53.2536 34.3897 34.2287 41.3083 19.5239 32.0835L27.3056 31.7958Z",
    fill: "#98CEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8757 32.878C35.3658 40.8926 53.2537 34.3896 53.2537 34.3896C53.4044 33.7914 53.377 33.1931 53.2537 32.636C32.6669 38.8833 25.3511 34.4033 23.054 31.9556L21.3506 32.0195L20.8711 32.8826L20.8757 32.878Z",
    fill: "#5A8BCB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0805 29.4895C18.0805 29.4895 34.2238 33.2387 44.3163 24.8771C44.3163 24.8771 46.6225 26.0325 46.6225 27.7587C46.6225 27.7587 33.3607 35.5403 17.5051 32.371L18.0805 29.4895Z",
    fill: "#98CEFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6225 27.759C46.6225 27.211 46.3895 26.7223 46.0744 26.3068C28.7575 34.9013 19.7702 32.28 17.6924 31.4352L17.5051 32.3714C33.3607 35.5407 46.6225 27.759 46.6225 27.759Z",
    fill: "#5A8BCB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7022 19.3971L22.0722 20.7671L8.37208 76.9376H7.45874L8.82875 60.9542C8.82875 60.9542 10.6554 44.9707 11.1121 44.514C11.5688 44.0573 14.7655 28.9872 15.2221 28.9872C15.6788 28.9872 20.7022 19.3971 20.7022 19.3971Z",
    fill: "#513F42"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.34839 76.481L13.3952 18.4838L20.7019 19.3971L7.45843 76.9377L3.34839 76.481Z",
    fill: "#6A5357"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9022 27.1104H18.9258L17.7613 32.1748L10.9478 32.6132L11.9022 27.1104Z",
    fill: "#98CEFE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8756 27.1605L20.2456 28.0739L19.3323 32.6406L17.6929 32.1793L18.8756 27.1605Z",
    fill: "#5A8BCB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4136 35.6912L16.8207 36.2483L15.6151 41.5H9.40894L10.4136 35.6912Z",
    fill: "#8BB7CB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1857 36.7004L16.7837 36.2438L15.5781 41.5001L16.9253 41.8608L18.1857 36.7004Z",
    fill: "#5A8BCB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5488 17.2247C37.2366 9.563 30.0559 2.65729 20.5102 1.80032C10.9645 0.94335 2.66861 6.45965 1.98078 14.1213C1.29295 21.783 8.47366 28.6887 18.0193 29.5457C27.565 30.4027 35.8609 24.8863 36.5488 17.2247Z",
    fill: "#F3F7BB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1125 17.4015C12.875 20.041 10.852 22.0138 8.59144 21.8083C6.33092 21.6074 4.69148 19.3012 4.92438 16.6662C5.16185 14.0266 7.18489 12.0538 9.44541 12.2593C11.7059 12.4648 13.3454 14.7665 13.1125 17.4015Z",
    fill: "#534437"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5976 18.7964C28.8344 16.1588 26.99 13.8378 24.4779 13.6123C21.9659 13.3868 19.7376 15.3422 19.5008 17.9798C19.264 20.6174 21.1084 22.9384 23.6204 23.164C26.1325 23.3895 28.3608 21.4341 28.5976 18.7964Z",
    fill: "#534437"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5056 27.0052L6.94254 24.8726C6.94254 24.8726 4.17968 30.1288 8.68703 30.9874L16.8341 32.1747C16.8341 32.1747 20.3915 33.4123 20.5056 27.0006V27.0052Z",
    fill: "#F3F7BB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8445 3.36785C29.3425 6.60108 30.676 10.7065 30.2878 15.0404C29.6667 21.9681 24.8352 27.5257 18.4646 29.5579C27.8081 30.1927 35.8409 24.7355 36.5168 17.2004C37.0374 11.3733 33.0096 5.98914 26.8491 3.36328L26.8445 3.36785Z",
    fill: "#DCE29E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinterStickMRSkull);
export default __webpack_public_path__ + "static/media/winter_stick_m_r_skull.cdb3dea4b68a98bb40a9e3044eb706e8.svg";
export { ForwardRef as ReactComponent };